import { Component, ViewChild,AfterViewInit,ElementRef,Output,EventEmitter,Input } from '@angular/core';
import {MediaService} from '../peers/media.service';
import {Modal} from 'ng2-modal';
import {environment} from '../../../environments/environment';
import { RecordingManagerService } from 'app/wb/services/recording/recording-manager.service';
@Component({
  selector: "dskl-tools-close",
  templateUrl: 'close.component.html',
  
})

export class CloseComponent {
  hidden=true;
  
  @ViewChild("closeModal") closeModal: Modal;
  
  
  constructor(private mediaService: MediaService, public recordingManager: RecordingManagerService){}
  open(){
    this.closeModal.open();
  }
  close(){
     window.close();
     window.location.href=environment.closeRedirection;

  }
  fromRecordingPlayer(){
    return this.recordingManager.allowRecording;
  }
}


// WEBPACK FOOTER //
// /app/src/app/wb/tools/close.component.ts